<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine></BaseTopLine>
    <div>
      <VueTabs
        v-model="activateTab"
        @tab-change="handleTabChange"
        class="vue-tabs-type-1"
      >
        <VTab :title="dataLang['cities_register_text_1']" data-name="cities">
          <div
            v-if="dataLang['cities_register_text_1'] == activateTab"
            class="tw-px-[26px] tw-my-[15px]"
          >
            <div class="tw-flex tw-gap-[10px]">
              <button
                class="tw-app-btn-primary"
                @click="$modal.show('citiesModal')"
              >
                <img
                  :src="require(`@/assets/icons/addwhite.svg`)"
                  width="13.5"
                  height="13.5"
                />
                {{ dataLang["cities_register_text_4"] }}
              </button>
              <button
                class="tw-app-btn-primary-outline"
                @click="toArchive('cities')"
              >
                <img :src="require(`@/assets/icons/to-exel.svg`)" height="15" />
                {{ dataLang["cities_register_text_5"] }}
              </button>
            </div>

            <div class="tw-flex tw-justify-between tw-mt-[15px]">
              <div class="tw-flex tw-gap-[10px]">
                <button
                  class="tw-app-btn-primary-outline"
                  @click="clickLoadData(1, 'cities')"
                >
                  {{ dataLang["register_btn_filter_on"] }}
                </button>
                <button
                  class="tw-app-btn-light !tw-text-[#0056AF]"
                  @click="resetFilter('cities')"
                >
                  {{ dataLang["register_btn_filter_off"] }}
                </button>
              </div>

              <TwBasePagination
                :page-count="numPagesCities"
                :pagination-params="{
                  ...paginationCitiesStateParams,
                  limit: limitPaginationValue,
                }"
                :showLimitInput="true"
                @updateLimitValue="updateLimitValue($event, 'cities')"
                :page-range="10"
                :margin-pages="0"
                :click-handler="(num) => clickLoadData(num, 'cities')"
              >
              </TwBasePagination>
            </div>

            <div class="tw-relative tw-mt-[15px]">
              <BaseLoader v-if="localLoading"></BaseLoader>
              <ve-table
                class="rest-style-table fixed-header"
                style="width: 100%"
                :columns="columns"
                :table-data="dataTable"
                :border-x="true"
                :border-y="true"
                ref="refTable"
                row-key-field-name="cities__id"
                :eventCustomOption="eventCustomOption"
                v-if="!localLoading"
                :clickHighlight="false"
                :rowStyleOption="{
                  hoverHighlight: true,
                }"
                :cellSelectionOption="{ enable: false }"
              />
            </div>
          </div>

          <BaseModal
            name="citiesModal"
            width="420"
            :clickToClose="false"
            @before-open="beforeOpen"
            @before-close="beforeClose"
            :shiftY="0.5"
            :adaptive="true"
            height="auto"
            classes="tw-app-modal"
          >
            <div class="tw-app-modal__container">
              <button
                type="button"
                class="btn-close tw-app-modal__close"
                @click="$modal.hide('citiesModal')"
              ></button>

              <div>
                <div class="tw-app-modal__title">
                  {{ dataLang.cities_register_text_10 }}
                </div>

                <div
                  class="d-flex justify-content-between mb-10 align-items-center"
                  ref="cities__country_id"
                >
                  <span class="tw-text-[11px]">
                    {{ dataLang.cities_register_text_8 }}
                  </span>
                  <div class="multiselect-type-2">
                    <BaseSelect
                      style="width: 253px"
                      placeholder=""
                      selectLabel=""
                      deselectLabel=""
                      @input="
                        (data) =>
                          setSimpleSelect({
                            key: 'cities__country_id',
                            value: data.countries__id,
                          })
                      "
                      v-model="selectsFromModal.countries"
                      :options="selectsData.countries"
                      label="countries__name"
                    >
                      <template slot="noOptions">{{
                        dataLang["select_empty"]
                      }}</template>
                      <template slot="noResult">{{
                        dataLang["select_search_empty"]
                      }}</template
                      ><template slot="selectedLabel">{{
                        dataLang["select_selected"]
                      }}</template>
                      <template slot="deselectLabel">{{
                        dataLang["select_unselect"]
                      }}</template>
                    </BaseSelect>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between mb-10 align-items-center"
                >
                  <span class="tw-text-[11px]">
                    {{ dataLang.cities_register_text_9 }}
                  </span>
                  <div class="multiselect-type-2">
                    <BaseSelect
                      style="width: 253px"
                      placeholder=""
                      selectLabel=""
                      deselectLabel=""
                      noOption=""
                      @input="
                        (data) =>
                          setSimpleSelect({
                            key: 'cities__region_id',
                            value: data.regions__id,
                          })
                      "
                      v-model="selectsFromModal.region"
                      :options="selectsData.region"
                      label="regions__name"
                    >
                      <template slot="noOptions">{{
                        dataLang["select_empty"]
                      }}</template>
                      <template slot="noResult">{{
                        dataLang["select_search_empty"]
                      }}</template
                      ><template slot="selectedLabel">{{
                        dataLang["select_selected"]
                      }}</template>
                      <template slot="deselectLabel">{{
                        dataLang["select_unselect"]
                      }}</template>
                    </BaseSelect>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between mb-10 align-items-center"
                  ref="cities__name"
                >
                  <span class="tw-text-[11px]">
                    {{ dataLang.cities_register_text_10 }}
                  </span>
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    placeholder=""
                    width="253"
                    class="lh-1"
                    input-name="cities__name"
                    maxLength="100"
                    @input="updateValue"
                    :horizontalTitle="true"
                    signClass="text-dark fsc-11"
                    :value="dataForModal.cities__name"
                    :additionalParams="{}"
                    name-sign=""
                  >
                  </BaseInputNew>
                </div>
                <div
                  class="d-flex justify-content-between mb-10 align-items-center"
                >
                  <span class="tw-text-[11px]">
                    {{ dataLang.cities_register_text_20 }}
                  </span>

                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    placeholder=""
                    width="253"
                    class="lh-1"
                    input-name="cities__center_address"
                    maxLength="100"
                    @input="updateValueCitiesCenter"
                    :horizontalTitle="true"
                    signClass="text-dark fsc-11"
                    :value="valueAddress"
                    @selectData="onSelectFromAddress"
                    :additionalParams="{}"
                    name-sign=""
                    :options="addressOptions"
                    selectKey="formatted_address"
                    selectFocusmethod="input"
                  >
                  </BaseInputNew>
                </div>
                <div
                  class="d-flex justify-content-between mb-10 align-items-center"
                  ref="cities__utc"
                >
                  <span class="tw-text-[11px]">
                    {{ dataLang.cities_register_text_11 }}
                  </span>

                  <div class="multiselect-type-2">
                    <BaseSelect
                      style="width: 253px"
                      placeholder=""
                      selectLabel=""
                      deselectLabel=""
                      @input="
                        (data) =>
                          setSimpleSelect({
                            key: 'cities__utc',
                            value: data.time,
                          })
                      "
                      v-model="selectsFromModal.time"
                      :options="selectsData.time"
                      :custom-label="({ time }) => 'UTC' + time"
                    >
                      <template slot="noOptions">{{
                        dataLang["select_empty"]
                      }}</template>
                      <template slot="noResult">{{
                        dataLang["select_search_empty"]
                      }}</template
                      ><template slot="selectedLabel">{{
                        dataLang["select_selected"]
                      }}</template>
                      <template slot="deselectLabel">{{
                        dataLang["select_unselect"]
                      }}</template>
                    </BaseSelect>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between mb-10 align-items-center"
                >
                  <span class="tw-text-[11px]">
                    {{ dataLang.cities_register_text_12 }}
                  </span>
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    placeholder=""
                    width="253"
                    class="lh-1"
                    input-name="cities__subdomain"
                    maxLength="100"
                    @input="updateValue"
                    :horizontalTitle="true"
                    signClass="text-dark fsc-11"
                    :value="dataForModal?.cities__subdomain"
                    :additionalParams="{}"
                    name-sign=""
                  >
                  </BaseInputNew>
                </div>
                <div
                  class="d-flex justify-content-between mb-10 align-items-center"
                >
                  <span class="tw-text-[11px]">
                    {{ dataLang.cities_register_text_13 }}
                  </span>
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    placeholder="+7(___)___-__ -__"
                    width="253"
                    class="lh-1"
                    input-name="cities__phone"
                    @input="updateValue"
                    :horizontalTitle="true"
                    signClass="text-dark fsc-11"
                    inputRef="cities__phone"
                    maxLength="16"
                    inputMask="+{7}(000)000-00-00"
                    :value="dataForModal?.cities__phone"
                    :additionalParams="{}"
                    name-sign=""
                  >
                  </BaseInputNew>
                </div>
              </div>
              <div class="tw-app-modal__footer">
                <button
                  @click="$modal.hide('citiesModal')"
                  class="tw-app-btn-muted tw-app-btn-muted-lg"
                >
                  Отмена
                </button>
                <button
                  @click="sendData(openedType, currentOpenedId)"
                  class="tw-app-btn-primary tw-app-btn-primary-lg"
                >
                  Создать
                </button>
              </div>
            </div>
          </BaseModal>

          <BaseModal
            name="citiesModalEdit"
            width="1280"
            @before-close="beforeClose"
            @before-open="loadDataEdit"
            :clickToClose="false"
            :shiftY="0.5"
            :adaptive="true"
            height="725"
            classes="bg-system-main-block shadow-none"
          >
            <!-- ШАПКА  -->
            <div
              class="d-flex justify-content-between px-30 py-5 align-items-center"
              style="height: 40px"
            >
              <BaseLoader v-if="localLoading"></BaseLoader>
              <div
                class="fsc-12"
                v-if="
                  dataForModal.cities__region_id && dataForModal.cities__name
                "
              >
                Регион:
                <span class="fw-bold">{{
                  selectsData.region.find(
                    (x) => dataForModal.cities__region_id == x.regions__id
                  ).regions__name
                }}</span
                >&nbsp;&nbsp; Город:
                <span class="fw-bold">{{ dataForModal.cities__name }}</span>
              </div>
              <button
                type="button"
                class="btn-close p-0 flex-shrink-0"
                @click="$modal.hide('citiesModalEdit')"
              ></button>
            </div>
            <!-- ШАПКА ТАБОВ -->
            <div class="vue-tabs">
              <div class="nav-tabs-navigation">
                <div class="nav-tabs-wrapper">
                  <ul role="tablist" class="nav nav-tabs">
                    <li
                      class="tab"
                      @click="handleTabChangeEdit('Город')"
                      :class="{
                        active: activateTabEdit == 'Город',
                      }"
                    >
                      <a
                        href="#"
                        role="tab"
                        class="tabs__link"
                        :class="{
                          active_tab: activateTabEdit == 'Город',
                        }"
                        ><span class="title title_center"> Город </span></a
                      >
                    </li>
                    <li
                      class="tab"
                      @click="handleTabChangeEdit('ОФ.Партнер')"
                      :class="{
                        active: activateTabEdit == 'ОФ.Партнер',
                      }"
                    >
                      <a
                        href="#"
                        :class="{
                          active_tab: activateTabEdit == 'ОФ.Партнер',
                        }"
                        class="tabs__link"
                        ><span class="title title_center"> ОФ.Партнер </span></a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- ТАБ ГЛАВНАЯ -->
            <div
              v-if="activateTabEdit == 'Город'"
              class="pb-10 d-flex flex-column"
              style="
                height: 588px;
                padding-left: 27px;
                padding-right: 27px;
                padding-top: 30px;
              "
            >
              <div
                style="width: 717px"
                class="d-flex justify-content-between mb-10 align-items-center"
                ref="cities__country_id"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang.cities_register_text_8
                }}</span>
                <BaseSelect
                  style="width: 610px"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  @input="
                    (data) =>
                      setSimpleSelect({
                        key: 'cities__country_id',
                        value: data.countries__id,
                      })
                  "
                  v-model="selectsFromModal.countries"
                  :options="selectsData.countries"
                  label="countries__name"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>
              <div
                style="width: 717px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang.cities_register_text_9
                }}</span>
                <BaseSelect
                  style="width: 610px"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  noOption=""
                  @input="
                    (data) =>
                      setSimpleSelect({
                        key: 'cities__region_id',
                        value: data.regions__id,
                      })
                  "
                  v-model="selectsFromModal.region"
                  :options="selectsData.region"
                  label="regions__name"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>
              <div
                style="width: 717px"
                class="d-flex justify-content-between mb-10 align-items-center"
                ref="cities__name"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang.cities_register_text_10
                }}</span>
                <BaseInputNew
                  placeholder=""
                  width="610"
                  class="lh-1"
                  input-name="cities__name"
                  maxLength="100"
                  @input="updateValue"
                  :horizontalTitle="true"
                  signClass="text-dark fsc-11"
                  inputClass=""
                  :value="dataForModal.cities__name"
                  :additionalParams="{}"
                  name-sign=""
                >
                </BaseInputNew>
              </div>
              <div
                style="width: 717px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang.cities_register_text_20
                }}</span>
                <BaseInputNew
                  placeholder=""
                  width="610"
                  class="lh-1"
                  input-name="cities__center_address"
                  maxLength="100"
                  @input="updateValueCitiesCenter"
                  :horizontalTitle="true"
                  signClass="text-dark fsc-11"
                  inputClass=""
                  :value="valueAddress"
                  @selectData="onSelectFromAddress"
                  :additionalParams="{}"
                  name-sign=""
                  :options="addressOptions"
                  selectKey="formatted_address"
                  selectFocusmethod="input"
                >
                </BaseInputNew>
              </div>
              <div
                style="width: 717px"
                class="d-flex justify-content-between mb-10 align-items-center"
                ref="cities__utc"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang.cities_register_text_11
                }}</span>
                <BaseSelect
                  style="width: 610px"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  @input="
                    (data) =>
                      setSimpleSelect({
                        key: 'cities__utc',
                        value: data.time,
                      })
                  "
                  v-model="selectsFromModal.time"
                  :options="selectsData.time"
                  :custom-label="({ time }) => 'UTC' + time"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>
              <div
                style="width: 717px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang.cities_register_text_12
                }}</span>
                <BaseInputNew
                  placeholder=""
                  width="610"
                  class="lh-1"
                  input-name="cities__subdomain"
                  maxLength="100"
                  @input="updateValue"
                  :horizontalTitle="true"
                  signClass="text-dark fsc-11"
                  inputClass=""
                  :value="dataForModal?.cities__subdomain"
                  :additionalParams="{}"
                  name-sign=""
                >
                </BaseInputNew>
              </div>
              <div
                style="width: 717px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang.cities_register_text_13
                }}</span>
                <BaseInputNew
                  placeholder="+7(___)___-__ -__"
                  width="610"
                  class="lh-1"
                  input-name="cities__phone"
                  @input="updateValue"
                  :horizontalTitle="true"
                  signClass="text-dark fsc-11"
                  inputClass=""
                  inputRef="cities__phone"
                  maxLength="16"
                  inputMask="+{7}(000)000-00-00"
                  :value="dataForModal?.cities__phone"
                  :additionalParams="{}"
                  name-sign=""
                >
                </BaseInputNew>
              </div>
            </div>

            <div
              v-if="activateTabEdit == 'ОФ.Партнер'"
              class="pb-10 d-flex flex-column"
              style="
                height: 588px;
                padding-left: 27px;
                padding-right: 27px;
                padding-top: 30px;
              "
            >
              <div
                style="width: 564px"
                class="d-flex justify-content-between mb-15 align-items-center"
                ref="cities__official_partner_id"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c"
                  >Официальный партнер</span
                >
                <BaseSelect
                  style="width: 428px"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  @input="onOfficialPartnerChange"
                  v-model="selectsFromModal.owners"
                  :options="selectsData.owners"
                  :custom-label="
                    ({ companies__id, companies__name }) =>
                      companies__id === null
                        ? companies__name
                        : `${companies__name} (${companies__id})`
                  "
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>

              <div
                style="width: 564px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">
                  {{ dataLang["cities_register_text_23"] }}
                </span>
                <BaseDatePicker
                  style="width: 211px"
                  v-model="dataForModal.cities__official_partner_before_date"
                  :clearable="false"
                  type="date"
                  class="fsc-11 idiots-class-for-input-date"
                  lang="ru"
                  :format="`${userSetting.company__tempalte_date}`"
                  value-type="format"
                  @change="
                    (date) =>
                      updateValue({
                        name: 'cities__official_partner_before_date',
                        value: date.split('.').reverse().join('-'),
                      })
                  "
                />
              </div>

              <div
                style="width: 564px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang["cities_register_text_24"]
                }}</span>
                <BaseInputNew
                  placeholder=""
                  width="211"
                  class="lh-1"
                  input-name="cities__official_partner_percent_1"
                  input-ref="cities__official_partner_percent_1"
                  maxLength="6"
                  :inputMask="{
                    mask: Number,
                    scale: 2,
                    signed: false,
                    min: 0,
                    max: 2.5,
                    thousandsSeparator: '',
                    padFractionalZeros: true,
                    normalizeZeros: true,
                    radix: '.',
                    mapToRadix: [','],
                  }"
                  @input="updateValue"
                  :horizontalTitle="true"
                  signClass="text-dark fsc-11"
                  inputClass=""
                  :key="dataForModal?.cities__official_partner_percent_1"
                  :value="dataForModal?.cities__official_partner_percent_1"
                  :additionalParams="{}"
                  name-sign=""
                />
              </div>

              <div
                style="width: 564px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang["cities_register_text_25"]
                }}</span>
                <BaseInputNew
                  placeholder=""
                  width="211"
                  class="lh-1"
                  input-name="cities__official_partner_percent_2"
                  input-ref="cities__official_partner_percent_2"
                  maxLength="6"
                  :inputMask="{
                    mask: Number,
                    scale: 2,
                    signed: false,
                    min: 0,
                    max: 2.5,
                    thousandsSeparator: '',
                    padFractionalZeros: true,
                    normalizeZeros: true,
                    radix: '.',
                    mapToRadix: [','],
                  }"
                  @input="updateValue"
                  :horizontalTitle="true"
                  signClass="text-dark fsc-11"
                  inputClass=""
                  :key="dataForModal?.cities__official_partner_percent_2"
                  :value="dataForModal?.cities__official_partner_percent_2"
                  :additionalParams="{}"
                  name-sign=""
                />
              </div>

              <div
                style="width: 564px"
                class="d-flex justify-content-between mb-10 align-items-center"
              >
                <span class="fsc-11 input-title" style="color: #1d1e2c">{{
                  dataLang["cities_register_text_31"]
                }}</span>
                <BaseInputNew
                  placeholder=""
                  width="211"
                  class="lh-1"
                  input-name="cities__official_partner_percent_3"
                  input-ref="cities__official_partner_percent_3"
                  maxLength="6"
                  :inputMask="{
                    mask: Number,
                    scale: 2,
                    signed: false,
                    min: 0,
                    max: 20,
                    thousandsSeparator: '',
                    padFractionalZeros: true,
                    normalizeZeros: true,
                    radix: '.',
                    mapToRadix: [','],
                  }"
                  @input="updateValue"
                  :horizontalTitle="true"
                  signClass="text-dark fsc-11"
                  inputClass=""
                  :key="dataForModal?.cities__official_partner_percent_3"
                  :value="dataForModal?.cities__official_partner_percent_3"
                  :additionalParams="{}"
                  name-sign=""
                />
              </div>
            </div>

            <!-- КНОПКИ СОХРАНЕНИЯ -->
            <div class="tw-app-modal__footer !tw-justify-end tw-px-[15px]">
              <button
                @click="$modal.hide('citiesModalEdit')"
                class="tw-app-btn-muted tw-app-btn-muted-lg"
              >
                Отменить
              </button>
              <button
                @click="sendData(openedType, currentOpenedId)"
                class="tw-app-btn-primary tw-app-btn-primary-lg"
              >
                Сохранить и закрыть
              </button>
            </div>
          </BaseModal>
        </VTab>
        <VTab :title="dataLang['cities_register_text_2']" data-name="regions">
          <div v-if="dataLang['cities_register_text_2'] == activateTab">
            <div
              class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mt-[15px]"
              ref="topFilter"
              :key="counter"
            >
              <div
                class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[600px]"
              >
                <div class="tw-app-input-container" ref="cities__country_id">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["cities_register_text_8"] }}
                  </label>
                  <BaseSelect
                    class="multiselect-type-1"
                    placeholder=""
                    selectLabel=""
                    deselectLabel=""
                    @input="
                      (data) =>
                        setSimpleSelect({
                          key: 'regions__country_id',
                          value: data.countries__id,
                        })
                    "
                    v-model="selectsFromModal.countries"
                    :options="selectsData.countries"
                    label="countries__name"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template
                    ><template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang.cities_register_text_17 }}
                  </label>
                  <BaseInputNew
                    inputClass="tw-app-input-dark"
                    placeholder=""
                    input-name="regions__name"
                    maxLength="100"
                    @input="updateValue"
                    :horizontalTitle="true"
                    value=""
                    :additionalParams="{}"
                    name-sign=""
                  />
                </div>

                <div class="tw-flex tw-flex-row">
                  <button
                    type="button"
                    class="tw-app-btn-primary"
                    @click="sendDataFromOtherTab('regions')"
                  >
                    Добавить
                  </button>
                </div>
              </div>
            </div>
            <div
              class="tw-px-[26px] tw-my-[15px] tw-flex tw-justify-between tw-mt-[15px]"
            >
              <div class="tw-flex tw-gap-[10px]">
                <button
                  class="tw-app-btn-primary-outline"
                  @click="clickLoadData(1, 'regions')"
                >
                  {{ dataLang["register_btn_filter_on"] }}
                </button>
                <button
                  class="tw-app-btn-light !tw-text-[#0056AF]"
                  @click="resetFilter('regions')"
                >
                  {{ dataLang["register_btn_filter_off"] }}
                </button>
                <button
                  class="tw-app-btn-primary-outline"
                  @click="toArchive('regions')"
                >
                  <img
                    :src="require(`@/assets/icons/to-exel.svg`)"
                    height="15"
                  />
                  {{ dataLang["cities_register_text_5"] }}
                </button>
              </div>
              <TwBasePagination
                :page-count="numPagesCities"
                :pagination-params="{
                  ...paginationCitiesStateParams,
                  limit: limitPaginationValue,
                }"
                :showLimitInput="true"
                @updateLimitValue="updateLimitValue($event, 'regions')"
                :page-range="10"
                :margin-pages="0"
                :click-handler="(num) => clickLoadData(num, 'regions')"
              >
              </TwBasePagination>
            </div>
            <div class="tw-px-[26px] tw-relative">
              <ve-table
                class="rest-style-table fixed-header"
                style="width: 100%"
                :columns="columnsRegion"
                :table-data="dataTable"
                :border-x="true"
                :border-y="true"
                ref="refTable"
                row-key-field-name="cities__id"
                v-if="!localLoading"
                :clickHighlight="false"
                :rowStyleOption="{
                  hoverHighlight: true,
                }"
                :cellSelectionOption="{ enable: false }"
              />
            </div>
          </div>
        </VTab>
        <VTab :title="dataLang['cities_register_text_3']" data-name="countries">
          <div v-if="dataLang['cities_register_text_3'] == activateTab">
            <div
              class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mt-[15px]"
              ref="topFilter"
              :key="counter"
            >
              <div
                class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[900px]"
              >
                <div class="tw-app-input-container" ref="countries__name">
                  <label class="tw-app-input-container-label">
                    {{ dataLang.cities_register_text_18 }}
                  </label>
                  <BaseInputNew
                    inputClass="tw-app-input-dark"
                    input-name="countries__name"
                    maxLength="100"
                    @input="updateValue"
                    :horizontalTitle="true"
                    value=""
                    :additionalParams="{}"
                    name-sign=""
                  />
                </div>

                <div class="tw-app-input-container" ref="countries__phone_mask">
                  <label class="tw-app-input-container-label">
                    {{ dataLang.cities_register_text_19 }}
                  </label>
                  <BaseInputNew
                    inputClass="tw-app-input-dark"
                    input-name="countries__phone_mask"
                    maxLength="100"
                    @input="updateValue"
                    :horizontalTitle="true"
                    value=""
                    :additionalParams="{}"
                    name-sign=""
                  />
                </div>

                <div class="tw-app-input-container" ref="cities__country_id">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["cities_register_text_21"] }}
                  </label>
                  <BaseSelect
                    class="multiselect-type-1"
                    placeholder=""
                    selectLabel=""
                    deselectLabel=""
                    @input="
                      (data) =>
                        setSimpleSelect({
                          key: 'countries__language_id',
                          value: data.languages__id,
                        })
                    "
                    v-model="selectsFromModal.languages"
                    :options="selectsData.languages"
                    label="languages__name"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template
                    ><template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>

                <div class="tw-flex tw-flex-row">
                  <button
                    type="button"
                    class="tw-app-btn-primary"
                    @click="sendDataFromOtherTab('countries')"
                  >
                    Добавить
                  </button>
                </div>
              </div>
            </div>
            <div
              class="tw-px-[26px] tw-my-[15px] tw-flex tw-justify-between tw-mt-[15px]"
            >
              <div class="tw-flex tw-gap-[10px]">
                <button
                  class="tw-app-btn-primary-outline"
                  @click="clickLoadData(1, 'countries')"
                >
                  {{ dataLang["register_btn_filter_on"] }}
                </button>
                <button
                  class="tw-app-btn-light !tw-text-[#0056AF]"
                  @click="resetFilter('countries')"
                >
                  {{ dataLang["register_btn_filter_off"] }}
                </button>
                <button
                  class="tw-app-btn-primary-outline"
                  @click="toArchive('countries')"
                >
                  <img
                    :src="require(`@/assets/icons/to-exel.svg`)"
                    height="15"
                  />
                  {{ dataLang["cities_register_text_5"] }}
                </button>
              </div>
              <TwBasePagination
                :page-count="numPagesCities"
                :pagination-params="{
                  ...paginationCitiesStateParams,
                  limit: limitPaginationValue,
                }"
                :showLimitInput="true"
                @updateLimitValue="updateLimitValue($event, 'countries')"
                :page-range="10"
                :margin-pages="0"
                :click-handler="(num) => clickLoadData(num, 'countries')"
              >
              </TwBasePagination>
            </div>
            <div class="tw-px-[26px] tw-relative">
              <ve-table
                class="rest-style-table fixed-header"
                style="width: 100%"
                :columns="columnsCountries"
                :table-data="dataTable"
                :border-x="true"
                :border-y="true"
                ref="refTable"
                row-key-field-name="countries__id"
                v-if="!localLoading"
                :clickHighlight="false"
                :rowStyleOption="{
                  hoverHighlight: true,
                }"
                :cellSelectionOption="{ enable: false }"
              />
            </div>
          </div>
        </VTab>
      </VueTabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import NoticesService from "@/api/NoticesService.js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import GeneralService from "@/api/GeneralService";
export default {
  components: {
    VeTable,
    VTab,
    VueTabs,
  },

  props: {},
  data() {
    return {
      counter: 0,
      limitPaginationValue: 50,
      updatedValues: {},
      activeSelectRow: null,
      dataTable: null,
      dataForModal: {},
      dataTableRegion: null,
      localLoading: true,
      activateTab: "",
      activateTabEdit: "Город",
      addressOptions: [],
      valueAddress: "",
      filter: [],
      selectsData: {
        languages: [],
        countries: [],
        region: [],
        time: [],
        integrator: [],
        owners: [],
      },
      selectsFilter: {
        countries: [],
        region: [],
        time: [],
        integrator: [],
      },
      selectsFromModal: {
        countries: [],
        region: [],
        time: [],
        integrator: [],
        owners: [],
      },
      openedType: "create",
      currentOpenedId: null,
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.currentOpenedId = row.cities__id;
              this.openedType = "edit";
              GeneralService.get(
                `/cities?where=[{"field":"cities__id","value":${row.cities__id}}]`
              )
                .then((data) => {
                  this.dataForModal = data.data.data.rows[0];
                  this.valueAddress =
                    data.data.data.rows[0].cities__center_address;
                  this.selectsFromModal.countries =
                    this.selectsData.countries.find((x) => {
                      return (
                        x.countries__id ==
                        data.data.data.rows[0].cities__country_id
                      );
                    });
                  this.selectsFromModal.region = this.selectsData.region.find(
                    (x) => {
                      return (
                        x.regions__id ==
                        data.data.data.rows[0].cities__region_id
                      );
                    }
                  );

                  this.selectsFromModal.time = this.selectsData.time.find(
                    (x) => {
                      return x.time == data.data.data.rows[0].cities__utc;
                    }
                  );
                  this.selectsFromModal.integrator =
                    this.selectsData.integrator.find((x) => {
                      return (
                        x.integrators__id ==
                        data.data.data.rows[0].cities__integrator_id
                      );
                    });

                  this.selectsFromModal.owners = this.selectsData.owners.find(
                    (x) => {
                      return (
                        x.companies__id ==
                        data.data.data.rows[0].cities__official_partner_id
                      );
                    }
                  );

                  this.dataForModal.cities__official_partner_before_date =
                    data.data.data.rows[0].cities__official_partner_before_date
                      .split("-")
                      .reverse()
                      .join(".");
                })
                .catch((error) => {});
              this.$modal.show("citiesModalEdit", {
                mode: "edit",
                id: row.cities__id,
              });
            },
          };
        },
      },
      timeout: null,
    };
  },
  methods: {
    onOfficialPartnerChange(selectedOption) {
      const partnerId = selectedOption?.companies__id ?? null;
      this.setSimpleSelect({
        key: "cities__official_partner_id",
        value: partnerId,
      });

      if (partnerId === null) {
        this.dataForModal.cities__official_partner_before_date = null;
        this.updatedValues.cities__official_partner_before_date = null;
        this.dataForModal.cities__official_partner_percent_1 = 0;
        this.updatedValues.cities__official_partner_percent_1 = 0;
        this.dataForModal.cities__official_partner_percent_2 = 0;
        this.updatedValues.cities__official_partner_percent_2 = 0;
        this.dataForModal.cities__official_partner_percent_3 = 0;
        this.updatedValues.cities__official_partner_percent_3 = 0;
      }
    },
    loadDataEdit() {
      this.activateTabEdit = "Город";
    },
    updateValueCitiesCenter(e) {
      this.valueAddress = e.value;
      this.updatedValues.cities__center_address = e.value;
      this.addressOptions = [];
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        let data = await fetch(
          `https://suggest-maps.yandex.ru/v1/suggest?text=${e.value}&apikey=ebc56b08-9998-443e-99e9-e0a70c2cd1c1&print_address=1&types=country,house,house,district,geo,street,locality&lang=ru&results=15`
        );
        let dataFromJson = await data.json();
        dataFromJson.results.forEach((elem, index) => {
          this.addressOptions.push(elem.address);
        });
      }, 400);
    },
    onSelectFromAddress(e) {
      this.valueAddress = e.value.formatted_address;
      this.updatedValues.cities__center_address = e.value.formatted_address;
    },
    sendDataFromOtherTab(type) {
      GeneralService.editOrCreate(`/${type}`, {
        ...this.updatedValues,
      })
        .then((data) => {
          this.clickLoadData(1, type);
          this.$modal.hide("citiesModal");
          this.updatedValues = {};
          this.$toast.success(data.data.message);
          for (const key in this.selectsFromModal) {
            this.selectsFromModal[key] = [];
          }
          document.querySelectorAll(".linenew").forEach((element) => {
            element.querySelectorAll("input").forEach((elem) => {
              elem.value = "";
            });
          });
          this.counter++;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, { duration: 5000 });
          for (const key in this.selectsFromModal) {
            this.selectsFromModal[key] = [];
          }
        });
    },
    beforeClose() {
      for (const key in this.selectsFromModal) {
        this.selectsFromModal[key] = [];
      }
      this.dataForModal = {};
      this.updatedValues = {};
      this.openedType = "create";
      this.currentOpenedId = null;
    },
    beforeOpen() {},
    sendData(type, id) {
      if (type == "create") {
        GeneralService.editOrCreate("/cities", {
          ...this.updatedValues,
        })
          .then((data) => {
            this.clickLoadData(1, "cities");
            this.$modal.hide("citiesModal");
            this.$toast.success(data.data.message);
            this.updatedValues = {};
          })
          .catch((error) => {
            Object.keys(error.response.data.errors).forEach((elem, index) => {
              if (this.$refs[elem]) {
                this.$refs[elem].classList.add("input-error");
              }
            });
            this.$toast.error(error.response.data.message, { duration: 5000 });
          });
      } else {
        if (Object.keys(this.updatedValues).length) {
          GeneralService.edit(`/cities/${id}`, {
            ...this.updatedValues,
          })
            .then((data) => {
              this.$modal.hide("citiesModal");
              this.$toast.success(data.data.message);
              this.updatedValues = {};
              this.clickLoadData(1, "cities");
            })
            .catch((error) => {
              Object.keys(error.response.data.errors).forEach((elem, index) => {
                if (this.$refs[elem]) {
                  this.$refs[elem].classList.add("input-error");
                }
              });
              this.$toast.error(error.response.data.message, {
                duration: 5000,
              });
            })
            .finally(() => {
              this.$modal.hide("citiesModalEdit");
            });
        } else {
          this.$modal.hide("citiesModalEdit");
        }
      }
    },
    checkDate() {
      const dateString = this.dataForModal.cities__official_partner_before_date;
      if (!dateString) return;
      const [day, month, year] = dateString.split(".").map(Number);
      const inputDate = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (inputDate <= today) {
        this.dataForModal.cities__official_partner_id = null;
        this.updatedValues.cities__official_partner_id = null;
        this.selectsFromModal.owners = this.selectsData.owners.find(
          (x) => x.companies__id === null
        );
        this.onOfficialPartnerChange({
          companies__id: null,
          companies__name: "Не выбрано",
        });
      }
    },

    handleTabChangeEdit(tabName) {
      if (tabName == "ОФ.Партнер") {
        this.activateTabEdit = tabName;
        this.checkDate();
      } else {
        this.activateTabEdit = tabName;
      }
    },

    handleTabChange(tabIndex, newTab, oldTab) {
      this.updatedValues = {};
      this.filter = [];
      this.clickLoadData(1, newTab.$attrs["data-name"]);
    },

    async toArchive(type) {
      let dataFrom = await GeneralService.toSpecExcel(
        `/${type}/table/main/xlsx?limit=5000`,
        {
          params: {
            where: JSON.stringify(this.filter),
          },
        }
      );

      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    updateLimitValue(data, reestrType) {
      this.limitPaginationValue = data;
      this.clickLoadData(1, reestrType);
    },
    clickLoadData(page = 1, reestrType) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/${reestrType}/table/main`, {
          params: {
            limit: this.limitPaginationValue,
            page: page,
            where: JSON.stringify(this.filter),
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.getCitiesAll(data.data.data);
          })
          .catch((error) => {}),
        GeneralService.get("/super/companies/table/main?limit=10000&where=[]")
          .then((data) => {
            const owners = data.data.data.rows || [];
            this.selectsData.owners = [
              { companies__id: null, companies__name: "Не выбрано" },
              ...owners,
            ];
          })
          .catch((error) => {}),
        GeneralService.get("/countries")
          .then((data) => {
            this.selectsData.countries = data.data.data.rows;
          })
          .catch((error) => {}),
        GeneralService.get("/languages")
          .then((data) => {
            this.selectsData.languages = data.data.languages.rows;
          })
          .catch((error) => {}),
        GeneralService.get("/regions")
          .then((data) => {
            this.selectsData.region = data.data.data.rows;
          })
          .catch((error) => {}),
        GeneralService.get(
          "integrators?joins=company&fields=integrators__id,company_settings__set_req_company_name,cities__official_partner_id"
        )
          .then((data) => {
            this.selectsData.integrator = data.data.data.rows;
          })
          .catch((error) => {}),
      ]).then(() => {
        let timeOpt = () => {
          let options = [];
          for (let i = -12; i <= 12; i++) {
            if (i > 0) i = "+" + i;
            else i = i + "";
            options.push({ time: i });
          }

          return options;
        };
        this.selectsData.time = timeOpt();
        this.localLoading = false;
      });
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;

      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    setSimpleSelect(data, id) {
      this.updatedValues[data.key] = data.value;
      if (this.$refs[data.key]) {
        this.$refs[data.key].classList.remove("input-error");
      }
    },
    resetFilter(reestrType) {
      this.filter = [];
      this.selectsFilter = {
        countries: [],
        region: [],
        time: [],
        integrator: [],
      };
      this.clickLoadData(1, reestrType);
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    ...mapActions("citiesPagiation", ["getCitiesAll"]),
  },
  mounted() {},

  created() {
    this.clickLoadData(1, "cities");
  },

  computed: {
    ...mapState("userSettingModule", ["userSetting", "countNotices"]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("citiesPagiation", ["paginationCitiesStateParams"]),
    ...mapGetters("citiesPagiation", ["numPagesCities"]),
    numPages() {
      return (
        this.paginationStateParams.total / this.paginationStateParams.limit
      );
    },
    columnsCountries() {
      return [
        {
          field: "countries__name",
          title: this.dataLang["cities_register_text_8"],
          key: "41",
          align: "left",
          width: "70%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"countries__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },

        {
          field: "countries__phone_mask",
          title: this.dataLang["cities_register_text_19"],
          align: "left",
          key: "24",
          width: "30%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
      ];
    },
    columnsRegion() {
      return [
        {
          field: "countries__name",
          title: this.dataLang["cities_register_text_8"],
          key: "41",
          align: "left",
          width: "30%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.countries}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find((x) => x.field == "regions__country_id")
                    ) {
                      this.filter.push({
                        field: "regions__country_id",
                        value: e.countries__id,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "regions__country_id"
                        )
                      ].value = e.countries__id;
                    }
                  }}
                  style={"width: 100%"}
                  label={"countries__name"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.countries}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "regions__name",
          title: this.dataLang["cities_register_text_9"],
          align: "left",
          key: "24",
          width: "70%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"regions__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
      ];
    },
    columns() {
      return [
        {
          field: "countries__name",
          title: this.dataLang["cities_register_text_8"],
          key: "41",
          align: "left",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.countries}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find((x) => x.field == "cities__country_id")
                    ) {
                      this.filter.push({
                        field: "cities__country_id",
                        value: e.countries__id,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "cities__country_id"
                        )
                      ].value = e.countries__id;
                    }
                  }}
                  style={"width: 100%"}
                  label={"countries__name"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.countries}
                ></BaseSelect>
              </div>
            );
          },
        },

        {
          field: "regions__name",
          title: this.dataLang["cities_register_text_9"],
          align: "left",
          key: "24",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.region}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find((x) => x.field == "cities__region_id")
                    ) {
                      this.filter.push({
                        field: "cities__region_id",
                        value: e.regions__id,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "cities__region_id"
                        )
                      ].value = e.regions__id;
                    }
                  }}
                  style={"width: 100%"}
                  label={"regions__name"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.region}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "cities__name",
          title: this.dataLang["cities_register_text_10"],
          align: "left",
          key: "22",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"cities__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "cities__center_address",
          title: this.dataLang["cities_register_text_20"],
          align: "left",

          key: "45",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
          //   renderBodyCell: ({ row, column, rowIndex }, h) => {
          //     return <span>{row.notices__text}</span>
          //   }
        },
        {
          field: "cities__utc",
          title: this.dataLang["cities_register_text_11"],
          align: "left",

          key: "323",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.time}
                  onInput={(e, w) => {
                    if (!this.filter.find((x) => x.field == "cities__utc")) {
                      this.filter.push({
                        field: "cities__utc",
                        value: e.time,
                        mod: "valueUTC",
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex((x) => x.field == "cities__utc")
                      ].value = e.time;
                    }
                  }}
                  style={"width: 100%"}
                  customLabel={({ time }) => "UTC" + time}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.time}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "cities__subdomain",
          title: this.dataLang["cities_register_text_12"],
          align: "left",
          key: "545",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "cities__phone",
          title: this.dataLang["cities_register_text_13"],
          align: "left",
          key: "5456",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "cities__count_places",
          title: this.dataLang["cities_register_text_14"],
          align: "left",
          key: "114",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "cities__count_objects",
          title: this.dataLang["cities_register_text_15"],
          align: "left",
          key: "4343",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "company_settings__set_req_company_name",
          title: "Оф. партнер",
          align: "left",
          key: "5321",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div
                style={"min-width: 120px; width: 100%"}
                class="multiselect-type-1 multiselect-type-1-small"
              >
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.integrator}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find(
                        (x) => x.field == "cities__official_partner_id"
                      )
                    ) {
                      this.filter.push({
                        field: "cities__official_partner_id",
                        value: e.cities__official_partner_id,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "cities__official_partner_id"
                        )
                      ].value = e.cities__official_partner_id;
                    }
                  }}
                  style={"min-width: 120px; width: 100%"}
                  label={"company_settings__set_req_company_name"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.integrator}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "cities__official_partner_before_date",
          title: this.dataLang["cities_register_text_27"],
          align: "left",
          key: "cities_op_date",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row }) => {
            return row.cities__official_partner_before_date
              ? this.$time(row.cities__official_partner_before_date).format(
                  `${this.userSetting.company__tempalte_date}`
                )
              : "";
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "cities__official_partner_percent_1",
          title: this.dataLang["cities_register_text_28"],
          align: "left",
          key: "cities_op_p1",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "cities__official_partner_percent_2",
          title: this.dataLang["cities_register_text_29"],
          align: "left",
          key: "cities_op_p2",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "cities__official_partner_percent_3",
          title: this.dataLang["cities_register_text_30"],
          align: "left",
          key: "cities_op_p3",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
